import { Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';

/*
  Generated class for the OpenMapsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OpenMapsProvider {

  constructor(
    public plt: Platform,
  ) {
  }

  public openMaps(lat, lng) {
    const geocoords = lat + ',' + lng;
    this.plt.ready().then(
      () => {
        if (this.plt.is('ios')) {
          window.open('maps://?q=' + geocoords, '_system');
        } else if (this.plt.is('android')) {
          const label = encodeURI('Activity Location');
          window.open('geo:' + geocoords + '?q=' + geocoords + '(' + label + ')', '_system');
        } else {
          const url = "https://maps.google.com/?q=" + geocoords;
          window.open(url);
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/providers/open-maps/open-maps.ts